export const PLAN_TYPE = {
	PERSONAL: "personal",
	GROUP: "group",
};

export const isGroupPlan = (type) => type === PLAN_TYPE.GROUP;
export const isPersonalPlan = (type) => type === PLAN_TYPE.PERSONAL;

export const isIsul = (planCode) => /^.*_isul$/.test(planCode);
